<template>
  <div class="payment">
    <add-payment-info
      v-if="preloadEnabled"
      :acquisition-flow="true"
      :gifting-flow="true"
      :show-text="false"
      heading=""
      @success="successAction"/>
  </div>
</template>

<script>
import UpdatePaymentInfo from '../../../subscription/UpdatePaymentInfo';

export default {
  components: {
    'add-payment-info': UpdatePaymentInfo,
  },
  props: {
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      preloadEnabled: false,
      postLoad: false,
      loadCsfAttempts: 25,
      csfAttemptCounter: 0,
    };
  },
  beforeMount() {
    this.enablePaymentForm();
  },
  methods: {
    successAction(paymentInfo) {
      this.$store.dispatch('saveAccordionSectionData', {
        formData: paymentInfo,
        index: this.index,
      });
    },
    enablePaymentForm() {
      // This plan assignment and dispatch is not used by the purchase gift flow.
      // It is only here to keep the billing modal from erroring.
      const plan = 'annual';
      this.$store.dispatch('selectPricingPlan', plan);
      if (plan) {
        this.$store.dispatch('deselectFreePlan');
      }
      // this setTimeout is a hack bc the form is trying to render before csf is loaded on the window
      this.checkForCsf();
    },
    // adyen docs are buried bc we are using 1.5 (old version).
    // No known hook for when csf has loaded on the window.
    checkForCsf() {
      setTimeout(() => {
        if (this.csfAttemptCounter < this.loadCsfAttempts) {
          if (window && window.csf) {
            this.preloadEnabled = true;
          } else {
            this.csfAttemptCounter++;
            this.checkForCsf();
          }
        }
      }, 200);
    },
  },
};

</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/variables.scss';

.payment {
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
}

</style>
